import { render, staticRenderFns } from "./AddCustomerPage.vue?vue&type=template&id=4f835eb4&scoped=true&"
import script from "./AddCustomerPage.vue?vue&type=script&lang=js&"
export * from "./AddCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerPage.vue?vue&type=style&index=0&id=4f835eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f835eb4",
  null
  
)

export default component.exports